import KunLoading11 from './src/index'

KunLoading11.install = function (Vue) {
	Vue.component(KunLoading11.name, KunLoading11);
}

export default KunLoading11;
